import { render, staticRenderFns } from "./ComparativoBotHumano.vue?vue&type=template&id=8c06185e&scoped=true"
import script from "./ComparativoBotHumano.vue?vue&type=script&lang=js"
export * from "./ComparativoBotHumano.vue?vue&type=script&lang=js"
import style0 from "./ComparativoBotHumano.vue?vue&type=style&index=0&id=8c06185e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c06185e",
  null
  
)

export default component.exports